import React from "react";
import { Fab, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function PATDeleteButton(props) {
  const {
    onClick,
    disabled,
    size,
    tooltipText,
    entityFlag,
    viewOnly,
    className,
  } = props;

  if (entityFlag === "tags" && viewOnly) {
    return null;
  }

  const button = (
    <Fab
      size="small"
      disabled={disabled}
      color="secondary"
      aria-label="delete"
      onClick={onClick}
      className={className || ""}
    >
      <DeleteIcon style={{ fontSize: size }} />
    </Fab>
  );

  return (
    <Tooltip title={tooltipText || "Delete"}>
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
